import React from "react";
import BaseTopPage from "../../../Base/BaseTopPage";

const keyName = `ZmuQMapPage`;
const title=`Зимний маршрутный учет. Карта плотности по выбранному виду. Не подключено.`;
export default class ZmuQMapPage extends BaseTopPage {
    constructor(props) {
        super(props);
        const context = this;
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, props);
        const now=new Date();
        document.setCookie('toFilter',now.toLocaleDateString());
        context.gridName="ZmuGrid";
        context.subElementName = 'MappingPage';
        context.tableName = 'mappings';
        context.filters = context.filters.filter(f=>['year','users','region','it'].indexOf(f.name)==-1)
        context.state = {
            content: [`<p></p>`]
            , title: title
        };
    }
}